/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:21:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-30 15:24:57
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/FeaturedProductsSection/index.tsx
 */
import React from 'react';
import css from './css.less';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { ArrowRightOutlined } from '@ant-design/icons';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const FeaturedProductsSection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    handleOnColorChange,
    colour,
    onClick,
    disableColorPicker,
    withoutCollapse,
  } = props;
  return (
    <div className={css.container}>
      <div
        className={`${css.jumpContainer} ${
          withoutCollapse ? css.fieldSection1 : ''
        }`}
        onClick={onClick}>
        <ArrowRightOutlined rev className={css.icon} />
        <div>{getI18n('salesChannelContent.index.editinPromotionPage')}</div>
      </div>
      {!disableColorPicker && (
        <Section className={withoutCollapse ? css.fieldSection2 : ''}>
          <ItemWrapper
            title={getI18n('salesChannelContent.index.titleTextColour')}>
            <ColorPicker
              multi
              onChange={handleOnColorChange}
              color={colour}
              // title={'Title Text Colour'}
            />
          </ItemWrapper>
        </Section>
      )}
    </div>
  );
};
export default FeaturedProductsSection;
